import Device from 'constants/deviceSizes';
import { appConfig } from 'config/customization';

export default {
  title: {
    width: '100%'
  },
  textContainer: {
    width: '100%'
  },
  sectionContainer: {
    width: '100%'
  },
  itemContentContainer: {
    display: 'flex',
    alignItems: 'flex-start',
    justifyContent: 'flex-start',
    textAlign: 'justify',
    paddingTop: 4,
    zIndex: 1,
    width: '70%',
    [Device.mobile]: {
      width: '100%'
    }
  },
  wrapperContainer: {
    width: 650,
    [Device.mobile]: {
      width: '100%'
    }
  },
  innerContainer: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    paddingTop: 21,
    width: '100%'
  },
  iconContainer: {
    borderBottomRightRadius: 100,
    borderTopRightRadius: 100,
    height: 125,
    width: 65,
    marginRight: 15,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    [Device.mobile]: {
      display: 'none'
    }
  },
  icon: {
    height: 25,
    width: 'auto'
  },
  minPadding: {
    paddingTop: 0
  },
  hr: {
    borderColor: appConfig.colors.lightGray,
    width: '75%',
    display: 'inline-block',
    [Device.mobile]: {
      width: '100%'
    }
  }
};
